import React from 'react';

const TableSkeleton = ({ rows = 5, columns = 6 }) => {
  return (
    <div className="w-full">
      {/* Table Header Skeleton */}
      <div className="grid gap-4 mb-4" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
        {Array.from({ length: columns })?.map((_, index) => (
          <div
            key={`header-${index}`}
            className="h-10 bg-muted rounded animate-shimmer"
          />
        ))}
      </div>
      {/* Table Rows Skeleton */}
      {Array.from({ length: rows })?.map((_, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          className="grid gap-4 mb-3"
          style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
        >
          {Array.from({ length: columns })?.map((_, colIndex) => (
            <div
              key={`cell-${rowIndex}-${colIndex}`}
              className="h-12 bg-muted/50 rounded animate-shimmer"
              style={{ animationDelay: `${(rowIndex * columns + colIndex) * 0.05}s` }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;